import * as React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { useMemo, useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import "./TableComponentOther.css";
import PaginationMaterial from "../PaginationMaterial/PaginationMaterial";
import { UserToken } from "../../context/hooks/useAuth";
import { jwtDecode } from "jwt-decode";

interface Data {
  id: number;
  calories: number;
  carbs: number;
  fat: number;
  name: string;
  protein: number;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  headCells: any;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
  } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

    let objUserTk: UserToken;
    if (localStorage.getItem("token")) {
      objUserTk = jwtDecode(localStorage.getItem("token") || "");
    } else {
      objUserTk = {} as UserToken;
    }
  return (
    <TableHead>
  <TableRow>
    {headCells.map((headCell: any) => (
      <TableCell
        key={headCell.id}
        align="center"
        padding={headCell.disablePadding ? "none" : "normal"}
        sortDirection={
          !headCell.disableSort && orderBy === headCell.id ? order : false
        }
      >
        {headCell.disableSort ? (
          headCell.label
        ) : (
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={createSortHandler(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        )}
      </TableCell>
    ))}
  </TableRow>
</TableHead>
  );
}

export default function TableComponentOther({
  headCells,
  rows,
  editItem,
  removeItem,
  applyTemplate,
  viewDocument,
  downloadDocument,
  page,
  rowsPerPage,
  getAll,
  totalItems,
  showId = true,
  signDocumentToUser,
  resendEmail,
}: any) {
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("calories");
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [dense, setDense] = React.useState(false);
  let objUserTk: UserToken;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "");
  } else {
    objUserTk = {} as UserToken;
  }

  const handleChangePage = (event: any, newPage: any) => {
    getAll(newPage);
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    //@ts-ignore
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((n: { id: any }) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const visibleRows = useMemo(
    () =>
      [...rows]
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [rows, order, orderBy, page, rowsPerPage]
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer
          sx={{
            fontFamily: '"Poppins", serif',
            color: "#000000d1",
            padding: "20px",
            "& th, & td": {
              fontFamily: '"Poppins", serif',
              color: "#000000d1",
            },
          }}
        >
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={headCells}
            />
            <TableBody>
              {visibleRows.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  {Object.keys(row).map((key) =>
                    (key === "id" && !showId) || key === "emailsSig" ? null : (
                      <TableCell align={"center"} key={`${row.id}-${key}`}>
                        {row[key]}
                      </TableCell>
                    )
                  )}
                  <TableCell align="center">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        style={{ backgroundColor: "#F9B233" }}
                        className="btn-icon-only text-light"
                        role="button"
                        size="sm"
                        color=""
                        id={`action-button-${index}`}
                        onClick={(e) => e.preventDefault()}
                      >
                        <i
                          className="fas fa-ellipsis-v"
                          style={{ color: "#fff" }}
                        />
                      </DropdownToggle>
                      <DropdownMenu right>
                        {editItem && (
                          <DropdownItem onClick={() => editItem(row.id)}>
                            Editar
                          </DropdownItem>
                        )}
                        {removeItem && (
                          <DropdownItem onClick={() => removeItem(row.id)}>
                            Excluir
                          </DropdownItem>
                        )}
                        {applyTemplate  && (
                          <DropdownItem onClick={() => applyTemplate (row.id)}>
                            Usar Template
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
